import { Component, Inject, Input, Optional } from '@angular/core';
import { NavService } from '../../../../../services/nav.service';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogData } from '../../../../includes/dialog/confirm/confirm.component';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import * as Global from '../../../../../global';
import { DatePipe, NgFor, NgIf, TitleCasePipe } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ToastService } from '@app/services/toast.service';
import { TripService } from '../../../../../services/trip.service';
@Component({
  selector: 'cancel-journey',
  standalone: true,
  imports: [
    MatToolbarModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    NgFor,
    MatCheckboxModule,
    DatePipe,
    NgIf,
    TitleCasePipe,
  ],
  templateUrl: './cancel-journey.component.html',
  styleUrl: './cancel-journey.component.scss',
})
export class CancelJourneyComponent {
  Global = Global;
  @Input() data: any = null;
  formGroup!: FormGroup;
  constructor(
    public toastr: ToastService,
    public navService: NavService,
    private tripService: TripService,
    private fb: FormBuilder,
    @Optional() private dialogRef: MatDialogRef<CancelJourneyComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {}
  ngOnInit() {
    this.formGroup = this.fb.group({
      cancelTripItineraryHotel: this.fb.array([]),
      groupTripsUsers: this.fb.array([]),
    });
    if (this.data?.operation == 'Journey') {
      this.initJourneyFormGroup();
    }
    if (this.data?.operation == 'Specific User') {
      this.initSpecificUserFormGroup();
    }
  }
  ngOnChanges() {
    this.formGroup = this.fb.group({
      cancelTripItineraryHotel: this.fb.array([]),
      groupTripsUsers: this.fb.array([]),
    });
    if (this.data?.operation == 'Journey') {
      this.initJourneyFormGroup();
    }
    if (this.data?.operation == 'Specific User') {
      this.initSpecificUserFormGroup();
    }
  }
  initJourneyFormGroup() {
    let data = this.data ?? this.dialogData ?? null;
    this.cancelTripItineraryHotel.clear();
    if (data.tripBy === 'Hotels') {
      data?.hotels.forEach((itinery: any) => {
        this.cancelTripItineraryHotel.push(
          this.newItinerary({
            ...itinery,
            isItinerary: false,
            isGroupTrip: data?.trip?.isGroupTrip ?? null,
            status_request: data?.status_request,
          })
        );
      });
    } else {
      data?.itinery.forEach((itinery_item: any) => {
        if (data.tripBy === itinery_item.tripBy) {
          itinery_item?.trips.forEach((element: any) => {
            this.cancelTripItineraryHotel.push(
              this.newItinerary({
                ...element,
                isItinerary: true,
                isGroupTrip: data?.trip?.isGroupTrip ?? null,
                status_request: data?.status_request,
              })
            );
          });
        }
      });
    }
  }
  initSpecificUserFormGroup() {
    let data = this.data ?? this.dialogData ?? null;
    this.groupTripsUsers.clear();
    data?.trip?.groupTrips.forEach((user: any) => {
      this.groupTripsUsers.push(
        this.newUser({ ...user, status_request: data?.status_request })
      );
    });
  }
  closeModal() {
    if (this.dialogData) {
      this.dialogRef.close(this.dialogData);
    } else {
      this.navService.openSideNav({ toogle: true });
    }
  }
  get groupTripsUsers() {
    return this.formGroup.get('groupTripsUsers') as FormArray;
  }
  get cancelTripItineraryHotel() {
    return this.formGroup.get('cancelTripItineraryHotel') as FormArray;
  }
  newItinerary(item: any = {}) {
    let formControl: any = {
      type: [this.data?.status_request ?? 'REQUEST'],
      isGroupTrip: [item?.isGroupTrip ?? null],
      id: [item?.id ?? null],
      tripBy: [item?.tripBy ?? null],
      departureDate: [item?.departureDate ?? null],
      departureCityName: [item?.departureCityName ?? null],
      cityName: [item?.cityName ?? null],
      checkIn: [item?.checkIn ?? null],
      checkInTime: [item?.checkInTime ?? null],
      checkOut: [item?.checkOut ?? null],
      checkOutTime: [item?.checkOutTime ?? null],
      arrivalCityName: [item?.arrivalCityName ?? null],
      noOfTickets: [item?.noOfTickets ?? null],
      noOfRoom: [item?.noOfRoom ?? null],
      isItinerary: [item?.isItinerary ?? false],
      isCancel: [
        {
          value: item?.isCancel ? true : false,
          disabled: item?.status_request == 'APPROVE' ? true : false,
        },
      ],
      cancelTripItineraryHotelUsers: this.initGroupUser(
        item,
        item?.isItinerary
      ),
    };
    if (this.data?.status_request == 'APPROVE') {
      formControl.isCanceled = item?.isCancel;
    }
    return this.fb.group(formControl);
  }
  initGroupUser(itninery: any, isItinerary: boolean) {
    if (this.data?.trip?.isGroupTrip) {
      let user: any = [];
      if (itninery?.cancelTripItineraryHotelUserDto?.length) {
        itninery?.cancelTripItineraryHotelUserDto.forEach((item: any) => {
          user.push(
            this.fb.group({
              isHotel: [!isItinerary],
              tripItineraryId: [item?.id ?? null],
              userId: [item?.userId ?? null],
              userName: [item?.user?.firstName + ' ' + item?.user?.lastName],
              email: [item?.user?.email ?? null],

              isCancelRequest: [
                {
                  value: item?.isCancelRequest ?? false,
                  disabled:
                    this.data?.status_request == 'APPROVE' ? true : false,
                },
              ],
            })
          );
        });
      } else {
        this.data?.trip.groupTrips.forEach((item: any) => {
          user.push(
            this.fb.group({
              isHotel: [!isItinerary],
              tripItineraryId: [itninery?.id ?? null],
              userId: [item?.userId ?? null],
              userName: [item?.user?.firstName + ' ' + item?.user?.lastName],
              email: [item?.user?.email ?? null],

              isCancelRequest: [
                {
                  value: item?.isCancelRequest ?? false,
                  disabled:
                    this.data?.status_request == 'APPROVE' ? true : false,
                },
              ],
            })
          );
        });
      }

      return this.fb.array(user);
    } else {
      return this.fb.array([]);
    }
  }
  newUser(item: any = {}) {
    let formControl: any = {
      userId: [item?.userId ?? null],
      userName: [item?.user?.firstName + ' ' + item?.user?.lastName],
      email: [item?.user?.email ?? null],

      isCancelRequest: [
        {
          value: item?.isCancelRequest ?? false,
          disabled: this.data?.status_request == 'APPROVE' ? true : false,
        },
      ],
    };
    return this.fb.group(formControl);
  }
  onSubmit(event: any) {
    let cancelTripItineraryHotel: any = [];
    this.cancelTripItineraryHotel.value.forEach((item: any) => {      
      if (this.data?.status_request == 'APPROVE') {
        if (item?.isCanceled) {
          cancelTripItineraryHotel.push({
            ...item,
            isCancel: true,
          });
        }
      } else {
        if (item?.isCancel) {
          cancelTripItineraryHotel.push({
            ...item,
          });
        }
      }
    });    
    if (cancelTripItineraryHotel?.length) {
      event.target.classList.add('btn-loading');
      event.target.disabled = true;

      this.tripService
        .cancelRequestTripItineraryHotel({
          cancelTripItineraryHotel: cancelTripItineraryHotel,
        })
        .subscribe({
          next: (res) => {
            this.toastr.success(`Cancelled successfully`);
            this.tripService.updateRefresh(true);
            this.closeModal();
          },
          error: (err) => {
            event.target.classList.remove('btn-loading');
            event.target.disabled = false;
          },
          complete: () => {
            event.target.classList.remove('btn-loading');
            event.target.disabled = false;
          },
        });
    } else {
      this.toastr.error('Please select itinerary to cancel.');
    }
  }
  specificUserRequestUpdate(event: any) {
    let groupTripsUsers: any = [];
    this.groupTripsUsers.value.forEach((item: any) => {
      if (this.data?.status_request == 'APPROVE') {
        groupTripsUsers.push({
          ...item,
        });
      } else {
        if (item?.isCancelRequest) {
          groupTripsUsers.push({
            ...item,
          });
        }
      }
    });
    if (groupTripsUsers?.length) {
      event.target.classList.add('btn-loading');
      event.target.disabled = true;

      this.tripService
        .cancelPacificUser({
          type: this.data?.status_request,
          tripId: this.data.trip?.id,
          groupTripsUsers: this.groupTripsUsers.value,
        })
        .subscribe({
          next: (res) => {
            this.toastr.success(`Cancel Request Sent successfully`);
            this.tripService.updateRefresh(true);
            this.closeModal();
          },
          error: (err) => {
            event.target.classList.remove('btn-loading');
            event.target.disabled = false;
          },
          complete: () => {
            event.target.classList.remove('btn-loading');
            event.target.disabled = false;
          },
        });
    } else {
      this.toastr.error('Please select User to Cancel Request.');
    }
  }
  getCancelTripItineraryHotelUsers(itemIndex: number): FormArray {
    return (this.cancelTripItineraryHotel.at(itemIndex) as FormGroup).get(
      'cancelTripItineraryHotelUsers'
    ) as FormArray;
  }
}
